import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.spadmin.companies', {
        url: '/companies',
        component: 'companySPAdminCompanyList',
        resolve: {},
    });
}




// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/company-list/company-list.state.js